// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__4KR66","footer":"ModalCreateQualiphyProcedure_footer__1xsqC","additionData":"ModalCreateQualiphyProcedure_additionData__3C6Ht"};